package com.fantasytenis.web.utils

import com.fantasytenis.shared.core.utils.SharedData

/**
 * Utility functions for contest display logic.
 */
object ContestUtils {

    /**
     * Returns the display name for a contest, stripping "- Free" suffix
     * when paid games are hidden (since all visible contests are free anyway).
     *
     * Examples:
     * - "Australian Open Men's Day 1 - Free" -> "Australian Open Men's Day 1" (when showPaidGames = false)
     * - "Australian Open Men's Day 1 - Free" -> "Australian Open Men's Day 1 - Free" (when showPaidGames = true)
     */
    fun getDisplayName(name: String): String {
        val showPaidGames = SharedData.showPaidGames.value
        return if (!showPaidGames) {
            name.removeSuffix(" - Free")
        } else {
            name
        }
    }

    /**
     * Nullable version for optional contest names.
     */
    fun getDisplayName(name: String?): String? {
        return name?.let { getDisplayName(it) }
    }
}
